var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonAdvisory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -1775.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Advisory",
    transform: "translate(1206.000000, 1775.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.837,0 32,7.164 32,16 C32,24.837 24.837,32 16,32 C7.164,32 0,24.837 0,16 C0,7.164 7.164,0 16,0 Z M25.336,6.664 L12.399,12.399 L6.664,25.336 L19.601,19.601 L25.336,6.664 Z M14.5865,14.5865 C15.3675,13.8055 16.6335,13.8055 17.4145,14.5865 C18.1955,15.3675 18.1955,16.6335 17.4145,17.4145 C16.6335,18.1955 15.3675,18.1955 14.5865,17.4145 C13.8055,16.6335 13.8055,15.3675 14.5865,14.5865 Z",
    id: 205
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonAdvisory);
export default __webpack_public_path__ + "static/media/common-advisory.63148dea.svg";
export { ForwardRef as ReactComponent };